import appboy from '@braze/web-sdk';

import {
  EAutoBrazeCTA,
  TBrazeCard,
  EProfileBrazeCTA,
  ERentersBrazeCTA,
} from '@@/auto/interfaces';

import { brazeCTAConfig } from '../../../auto/constants/brazeModals';

export function isBrazeCard(
  cards: (appboy.Card | TBrazeCard)[]
): cards is TBrazeCard[] {
  return (
    cards.filter((card) => (card as TBrazeCard).dismissed !== undefined)
      .length === cards.length
  );
}

export function isAutoBrazeModal(modal: unknown): modal is EAutoBrazeCTA {
  return brazeCTAConfig.auto[modal as EAutoBrazeCTA] !== undefined;
}

export function isProfileBrazeModal(modal: unknown): modal is EProfileBrazeCTA {
  return brazeCTAConfig.profile[modal as EProfileBrazeCTA] !== undefined;
}

export function isRentersBrazeModal(modal: unknown): modal is ERentersBrazeCTA {
  return brazeCTAConfig.renters[modal as ERentersBrazeCTA] !== undefined;
}
